export { default } from './GameControllerPeople'
